import { Trans, withI18n } from '@lingui/react'
import { bool, func, shape } from 'prop-types'
import { compose } from 'redux'

import ePrescription from 'views/assets/images/misc/e-prescription.svg'
import Modal from 'views/components/molecules/Modal'
import { RX_DIFFERENCE_MODAL_ID } from 'views/consts'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'

const RxDifferenceModal = ({ i18n, mountPoints, open }) => (
  <Modal
    data-qa-id="form-rx-selection-modal-info-modal"
    id={RX_DIFFERENCE_MODAL_ID}
    open={open}
    title={i18n._('rxDifferenceModal.title')}
  >
    <p className="a-h5">{i18n._('rxDifferenceModal.ePrescription.title')}</p>
    <p className="a-p">
      {i18n._('rxDifferenceModal.ePrescription.description')}
    </p>
    <img
      alt={i18n._('rxDifferenceModal.ePrescription.alt')}
      className="u-margin-auto--left u-margin-auto--right u-margin--top u-margin--bottom"
      height="136"
      src={ePrescription}
      width="271"
    />
    <p className="a-h5">
      {i18n._('rxDifferenceModal.ePrescription.codes.title')}
    </p>
    <Trans
      id="rxDifferenceModal.ePrescription.codes.description"
      components={[
        <p className="a-p" />,
        <p className="a-p" />,
        <p className="a-p" />,
      ]}
    />
    <a href={mountPoints.getRedeemERecipe()}>
      {i18n._('rxDifferenceModal.learnMore')}
    </a>
  </Modal>
)

RxDifferenceModal.propTypes = {
  i18n: shape({
    _: func.isRequired,
  }).isRequired,
  mountPoints: mountPointsType.isRequired,
  open: bool,
}

RxDifferenceModal.defaultProps = {
  open: false,
}

export default compose(withMountPoints, withI18n())(RxDifferenceModal)
